var map = {
	"./AashiqueAhmedIqbal.png": 597,
	"./BusinessintheTimeofContagion.jpeg": 598,
	"./KarunaWielenga.png": 599,
	"./LakshmiSubramanian.png": 600,
	"./LouizaRodrigues.png": 601,
	"./MadMenofBombay.png": 602,
	"./MilanBalaban.png": 603,
	"./PowerPrivilegePosture.jpeg": 604,
	"./SaritaSundar.png": 605,
	"./Speaker1.png": 606,
	"./SusiePak.png": 607,
	"./TheGlobalBlueJeansTransformation.jpg": 608,
	"./TimberTradeTrajectory.jpeg": 609,
	"./TraceyPanek.png": 610,
	"./TypewriterTipTip.png": 611,
	"./WilliamMazzarella.png": 612,
	"./details-banner/BusinessInTheTimeOfContagion.png": 613,
	"./details-banner/MadMenOfBombay.png": 614,
	"./details-banner/PowerPrivilegeposture.png": 615,
	"./details-banner/TheGlobalBlueJeans.png": 616,
	"./details-banner/TimberTradeTrajectory.png": 617,
	"./details-banner/TypewriterTipTip.png": 618
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 596;